import { DropDown } from "./index";

export const CrewTypeDropDown = (props) => {
  return <DropDown label="Crew Type" name="crewType" options={options} {...props} />;
};

const options = ["flight crew", "cabin crew"];
